var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-head"},[_c('div',{staticClass:"left"},[_c('img',{staticClass:"logo",attrs:{"src":_vm.logo}})]),_c('div',{staticClass:"line"}),_c('div',{staticClass:"right"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.pageName))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }